<template>
    <div class="text-muval-gray-2 flex flex-col px-5">
        <lottie-player
            src="/no-matches.json"
            class="m-auto mt-0 h-56 w-1/2 md:mt-10"
            background="transparent"
            speed="1"
            loop
            autoplay
        ></lottie-player>

        <div class="mx-auto flex w-full flex-col">
            <template v-if="session.isInternational">
                <span class="text-muval-gray-1 text-lg font-medium"> Thanks for completing your move details! </span>
                <span class="text-muval-gray-2 mt-2 text-left text-sm">
                    Our corporate team will review this information you've provided and will be in touch soon with quote
                    options.
                </span>
            </template>
            <template v-else>
                <span class="text-muval-gray-1 text-lg font-medium">
                    We're still working on finding options for your move.
                </span>
                <span class="text-muval-gray-2 mt-2 text-left text-sm">
                    Some locations and dates can take slightly longer to find availability for. Rest assured that our
                    team are working on it and can find a solution from our network of over 100 pre-screened and
                    verified service partners. We'll be in touch with you shortly.
                </span>
            </template>
            <span class="mt-4 text-sm">
                Can't wait? Call
                <a
                    href="tel:1300168825"
                    class="text-brand font-medium hover:underline"
                >
                    1300 168 825
                </a>
                to speak to a move specialist now<span v-show="slaask.show">
                    or chat with us
                    <a
                        class="text-brand cursor-pointer"
                        @click="slaask.toggleChat"
                    >
                        online
                    </a> </span
                >.
            </span>

            <div class="">
                <div
                    v-if="!moveStore.isCallbackRequested"
                    class="mt-4 text-sm"
                >
                    Alternatively
                    <a
                        class="text-brand cursor-pointer hover:underline"
                        @click="handleRequestCallback"
                    >
                        request a callback.
                    </a>
                </div>
                <div
                    v-else
                    class="text-success mt-4 flex items-center gap-1 text-base"
                >
                    Callback requested
                    <div class="bg-success flex h-4 w-4 items-center justify-center rounded-full">
                        <SvgIcon
                            class="text-white"
                            name="system-check"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ProductableType } from '@/types';
import { useSessionStore, useAppStore, useMoveStore } from '@/store';

const { slaask } = useAppStore();
const session = useSessionStore();
const moveStore = useMoveStore();

const handleRequestCallback = () => {
    session.requestCallback({ productable_type: ProductableType.MOVE });
};
</script>
